import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { COMMON_PAGE_TITLE } from '@hdms/shared/util-core';

export const COMMON_PAGE_TITLE_TRANSLATION_PROVIDER: FactoryProvider = {
  provide: COMMON_PAGE_TITLE,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): string => i18NextService.t('common.label.pageTitle')
};
